import { Component } from '@angular/core';
import { NavController, NavParams, ModalController, AlertController, PopoverController } from 'ionic-angular';
import { DIC } from '../../dic';
import { GN } from '../../../gn';
import * as moment from 'moment';
import { CalendarPage } from '../../calendar/calendar';

/**
 * Generated class for the DriversettingsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-shiftschedule',
  templateUrl: 'shiftschedule.html',
})
export class ShiftschedulePage {

  Group = []
  codeSappp = ''
  loadingData: boolean = true
  priv: boolean = false
  countVisible = 0;
  GroupElements = 0;
  selectedArray: any = [];
  selectedArrayNames: any = [];
  selectedArrayEmpOrg: any = [];
  orgidsstr = ''
  daytype = ''
  //daytypearr = [{ name: '' }, { name: 'monday' }, { name: 'tuesday' }, { name: 'wednesday' }, { name: 'thursday' }, { name: 'friday' }, { name: 'saturday' }, { name: 'sunday' }]
  dtstr = ''
  dtstrdb = ''
  w: any
  dayname = ''
  selectedEmployees = []

  constructor(public navCtrl: NavController, public popoverCtrl: PopoverController, public navParams: NavParams, public dic: DIC, public gn: GN, public modalCtrl: ModalController, public alertCtrl: AlertController) {
    this.w = navParams.get('w')
    this.orgidsstr = this.w.orgids
    this.dayname = navParams.get('dayname')
    //navParams.get('w').daytype
    this.daytype = navParams.get('w').daytype
    if (this.gn.user.ClientId == 711 || this.gn.user.ClientId == 357) {
      this.codeSappp = this.dic.l["codeSap"]
    }
    else {
      this.codeSappp = this.dic.l["code"]
    }


  }


  loadData() {
    //this.dtstr = moment().startOf('isoWeek').add(1, 'week').day(this.daytype).format('YYYY-MM-DD');
    this.dtstr = moment().day(this.daytype + 7).format(this.gn.user.DFormat);
    this.dtstrdb = moment().day(this.daytype + 7).format('YYYY-MM-DD');

    console.log(this.w.id, this.dtstrdb)

    this.gn.addLog(44);

    var _that = this
    var _vcera = moment().add(-1, 'days').format('YYYY-MM-DD') + ' ' + moment().add(-1, 'days').format('HH:mm:ss')
    var _denes = moment().format('YYYY-MM-DD') + ' ' + moment().add(-1, 'days').format('HH:mm:ss')
    this.priv = this.gn.getPriv('employees')


    this.gn._Post('/api/gn/getalldriversbyshiftdt', { shiftid: this.gn.crypt(this.w.id), dt: this.gn.crypt(this.dtstrdb) }, function (_dataSel) {
      if (_dataSel.length > 0) {
        _that.selectedEmployees = _dataSel[0].employeeids.split(',')
        _that.selectedArray = _dataSel[0].employeeids.split(',')
        _that.selectedArrayNames = _dataSel[0].employees.split(',')
        _that.selectedArrayEmpOrg = _dataSel[0].employeesorg.split(',')
      } else {
        _that.selectedEmployees = []
        _that.selectedArray = []
        _that.selectedArrayNames = []
        _that.selectedArrayEmpOrg = []
      }
      _that.gn._Post('/api/gn/getalldriversbyorgids', { cid: _that.gn.crypt(_that.gn.user.ClientId), uid: _that.gn.crypt(_that.gn.user.UserId), rid: _that.gn.crypt(_that.gn.user.RoleId), orgids: _that.gn.crypt(_that.orgidsstr) }, function (_data) {
        _that.Group = []
        // console.log(_data);
        _that.Group.push({ id: 0, name: _that.dic.l["Ungroupped"], vehicles: [], visible: true, countShow: 0 })
        for (var j = 0; j < _data.length; j++) {
          if (_data[j].organisationid + '' == '0' || _data[j].organisationid + '' == '-1') {
            _data[j].visible = true;
            _data[j].orgname = _that.dic.l["Ungroupped"];

            //da gi cekira tie sto se veke snimeni za toj den i smena, ako go smeni denot pak da bara getalldriversbyshift
            _data[j].checked = (_that.selectedEmployees.length > 0 && _that.selectedEmployees.indexOf(_data[j].id + '') != -1) ? true : false;
            // _data[j].cpstr = moment(_data[j].cp).format(_that.gn.user.DFormat) + ' ' + moment(_data[j].cp).format(_that.gn.user.TFormat)
            // var cp = moment(_data[j].cp).format('YYYY-MM-DD') + ' ' + moment(_data[j].cp).format('HH:mm:ss')
            // var lr = moment(_data[j].lastregistration).format('YYYY-MM-DD') + ' ' + moment(_data[j].cp).format('HH:mm:ss')
            // var nr = moment(_data[j].lastregistration).add(1, 'years').format('YYYY-MM-DD') + ' ' + moment(_data[j].cp).format('HH:mm:ss')

            // _data[j].lrstr = moment(_data[j].lastregistration).format(_that.gn.user.DFormat)
            // _data[j].nrstr = moment(_data[j].lastregistration).add(1, 'years').format(_that.gn.user.DFormat)
            // _data[j].cpclass = 'green'
            // _data[j].lrclass = 'green'
            // _data[j].nrclass = 'green'
            // if (cp < _vcera) { _data[j].cpclass = 'red' }
            // if (lr < _denes) { _data[j].lrclass = 'red' }
            // if (nr < _denes) { _data[j].nrclass = 'red' }
            _that.Group[_that.Group.length - 1].vehicles.push(_data[j])
            _that.GroupElements++;
          }
        }
        for (var i = 0; i < _that.gn.Organisations.length; i++) {
          _that.Group.push({ id: _that.gn.Organisations[i].id, name: _that.gn.Organisations[i].name, vehicles: [], visible: true, countShow: 0 })
          for (var j = 0; j < _data.length; j++) {
            // console.log(_data[j].organisationid, _that.gn.Organisations[i].id)
            if (_data[j].organisationid + '' == _that.gn.Organisations[i].id + '') {
              _data[j].borndatestr = (_data[j].borndate != null || _data[j].borndate != '') ? moment(_data[j].borndate).format(_that.gn.user.DFormat) : '/'
              _data[j].licenseexpstr = (_data[j].licenseexp != null || _data[j].licenseexp != '') ? moment(_data[j].licenseexp).format(_that.gn.user.DFormat) : '/'
              _data[j].visible = true;
              _data[j].orgname = _that.gn.Organisations[i].name
              _data[j].checked = (_that.selectedEmployees.length > 0 && _that.selectedEmployees.indexOf(_data[j].id + '') != -1) ? true : false;
              // _data[j].cpstr = moment(_data[j].cp).format(_that.gn.user.DFormat) + ' ' + moment(_data[j].cp).format(_that.gn.user.TFormat)
              // var cp = moment(_data[j].cp).format('YYYY-MM-DD') + ' ' + moment(_data[j].cp).format('HH:mm:ss')
              // var lr = moment(_data[j].lastregistration).format('YYYY-MM-DD') + ' ' + moment(_data[j].cp).format('HH:mm:ss')
              // var nr = moment(_data[j].lastregistration).add(1, 'years').format('YYYY-MM-DD') + ' ' + moment(_data[j].cp).format('HH:mm:ss')

              // _data[j].lrstr = moment(_data[j].lastregistration).format(_that.gn.user.DFormat)
              // _data[j].nrstr = moment(_data[j].lastregistration).add(1, 'years').format(_that.gn.user.DFormat)
              // _data[j].cpclass = 'green'
              // _data[j].lrclass = 'green'
              // _data[j].nrclass = 'green'
              // if (cp < _vcera) { _data[j].cpclass = 'red' }
              // if (lr < _denes) { _data[j].lrclass = 'red' }
              // if (nr < _denes) { _data[j].nrclass = 'red' }

              _that.Group[_that.Group.length - 1].vehicles.push(_data[j])
              _that.GroupElements++;

              // console.log('nesto da se desava', _that.Group)

            }
          }
        }
        //debugger
        // console.log('za drugata strana',_data)
        _that.loadingData = false
        // console.log(_that.Group)

      })
    })
  }

  ionViewDidLoad() {
    this.gn.tfBtn = false;
    // console.log('ionViewDidLoad VehiclesettinngsPage');
    this.loadData()
  }

  DeleteDriver(_id, _fullname) {
    var _that = this
    const confirm = this.alertCtrl.create({
      title: _fullname,
      message: this.dic.l["deldriver"],
      buttons: [
        {
          text: this.dic.l["NO"],
          handler: () => {
            // console.log('Disagree /clicked');
          }
        },
        {
          text: this.dic.l["YES"],
          handler: () => {
            // console.log('Agree clicked');
            _that.gn._Post('/api/gn/deletedriver', { did: _that.gn.crypt(_id) }, function (_data) {
              _that.loadData()
            })
          }
        }
      ]
    });
    confirm.present();
  }



  Save() {
    var _dat = {
      dt: this.gn.crypt(this.dtstrdb),
      employeesids: this.gn.crypt(this.selectedArray.toString()),
      employees: this.gn.crypt(this.selectedArrayNames.toString()),
      employeesorg: this.gn.crypt(this.selectedArrayEmpOrg.toString()),
      daytype: this.gn.crypt(this.daytype),
      shift: this.gn.crypt(this.w.shift),
      shiftstartend: this.gn.crypt(this.w.timefrom + '-' + this.w.timeto),
      shiftid: this.gn.crypt(this.w.id),
      uid: this.gn.crypt(this.gn.user.UserId),
      cid: this.gn.crypt(this.gn.user.ClientId),
      orgids: this.gn.crypt(this.w.orgids)
    }
    var _that = this
    this.gn._Post('/api/gn/insertshiftschedule', _dat, function (_data) {
      _that.navCtrl.pop()
    })


    //insert into shiftschedule table so selectedarray, datum, smena, vreme...
  }

  selectMember(data) {
    if (data.checked == true) {
      this.selectedArray.push(data.id);
      this.selectedArrayNames.push(data.fullname)
      this.selectedArrayEmpOrg.push(data.organisationid)
    }
    else {
      for (let i = 0; i < this.selectedArray.length; i++) {

        if (this.selectedArray[i] == data.id) {

          this.selectedArray.splice(i, 1);
          this.selectedArrayNames.splice(i, 1);
          this.selectedArrayEmpOrg.splice(i, 1);
        }
      }
    }
  }

  getItems(ev: any) {
    // console.log(ev);
    var val = ev.target.value;
    if (val == null) { val = '' }
    val = val.toLowerCase()
    this.searchEmployees(val);
  }

  searchEmployees(val) {
    if (val && val.trim() != '') {
      for (var i = 0; i < this.Group.length; i++) {
        var countshowvehicles = 0;
        for (let j = 0; j < this.Group[i].vehicles.length; j++) {
          if (this.Group[i].vehicles[j].code.indexOf(val) > -1) {
            // console.log(this.Group[i].vehicles[j].code, val)
            this.Group[i].vehicles[j].visible = true
            this.Group[i].visible = true;
            // this.countVisible --;
            // console.log(this.Group[i].visible)
          }
          else {
            if (this.gn._latcyr(this.Group[i].vehicles[j].fullname.toLowerCase()).indexOf(val) > -1 || this.gn._cyrlat(this.Group[i].vehicles[j].fullname.toLowerCase()).indexOf(val) > -1) {
              this.Group[i].vehicles[j].visible = true
              this.Group[i].visible = true;
            } else {
              if (this.gn._latcyr(this.Group[i].vehicles[j].orgname.toLowerCase()).indexOf(val) > -1 || this.gn._cyrlat(this.Group[i].vehicles[j].orgname.toLowerCase()).indexOf(val) > -1) {
                this.Group[i].vehicles[j].visible = true
                this.Group[i].visible = true;
              } else {
                this.Group[i].vehicles[j].visible = false
                this.Group[i].visible = false;
                this.countVisible++;
                countshowvehicles++;
              }
            }
          }
        }

        this.Group[i].countShow = countshowvehicles

      }
    } else {
      this.resetSearch()
    }
  }

  resetSearch() {
    this.countVisible = 0;
    for (var i = 0; i < this.Group.length; i++) {
      this.Group[i].visible = true
      this.Group[i].countShow = 0;
      for (let j = 0; j < this.Group[i].vehicles.length; j++) {
        this.Group[i].vehicles[j].visible = true;

      }
    }
  }

  openDatePopup(_ev, _lastfirst) {
    var _that = this;
    var datum = this.dtstrdb;

    let popover = this.popoverCtrl.create(CalendarPage, {
      d: datum, cb: function (d) {
        _that.dtstr = moment(d).format(_that.gn.user.DFormat)
        _that.dtstrdb = moment(d).format('YYYY-MM-DD')

        if (moment(d).format('YYYY-MM-DD') < moment().format('YYYY-MM-DD')) {
          _that.gn.tfBtn = true;
        } else {
          _that.gn.tfBtn = false;
        }

        _that.gn._Post('/api/gn/getalldriversbyshiftdt', { shiftid: _that.gn.crypt(_that.w.id), dt: _that.gn.crypt(_that.dtstrdb) }, function (_dataSel) {
          if (_dataSel.length > 0) {
            _that.selectedEmployees = _dataSel[0].employeeids.split(',')
            _that.selectedArray = _dataSel[0].employeeids.split(',')
            _that.selectedArrayNames = _dataSel[0].employees.split(',')
            _that.selectedArrayEmpOrg = _dataSel[0].employeesorg.split(',')
          } else {
            _that.selectedEmployees = []
            _that.selectedArray = []
            _that.selectedArrayNames = []
            _that.selectedArrayEmpOrg = []
          }

          for (var g = 0; g < _that.Group.length; g++) {
            for (var v = 0; v < _that.Group[g].vehicles.length; v++) {
              _that.Group[g].vehicles[v].checked = (_that.selectedEmployees.length > 0 && _that.selectedEmployees.indexOf(_that.Group[g].vehicles[v].id + '') != -1) ? true : false;
            }
          }
        })

        // _that._lastregistrationDT = d;
        // _that._lastregistration = moment(_that._lastregistrationDT).format(_that.gn.user.DFormat)

      }
    })
    popover.present({ ev: _ev });
  }



}



// WEBPACK FOOTER //
// ./src/pages/settings/workshift/shiftschedule.ts